import { TranslatedLabel } from '@aipb/gulliver/env/model';
import { EnvService } from '@aipb/gulliver/env/util';
import { FrameRepository } from '@aipb/gulliver/frame/data-access';
import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'fr-dashboard',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  @Input() verticalPadding = true;

  private env = inject(EnvService);
  private frameRepository = inject(FrameRepository);
  dashboard$ = combineLatest([this.frameRepository.activeApp$, this.frameRepository.configIds$]).pipe(
    map(([activeApp, configIds]) => {
      const configId = activeApp in configIds ? configIds[activeApp] : 'default';

      if (
        configId &&
        configId in this.env.raw.applications[activeApp] &&
        this.env.raw.applications[activeApp][configId]?.dashboard
      ) {
        return this.env.raw.applications[activeApp][configId]?.dashboard;
      }

      const appTitle = this.env.raw.applications?.[activeApp]?.[configId]?.title;

      return {
        menuTitle: {
          cs: 'Přehled',
          de: 'Armaturenbrett',
          en: 'Dashboard'
        },
        welcomeTextAbove: {
          cs: `Vítejte v aplikaci <b>${'cs' in appTitle ? appTitle['cs'] : activeApp}</b>`,
          de: `Willkommen in der App <b>${'de' in appTitle ? appTitle['de'] : activeApp}</b>`,
          en: `Welcome to app <b>${'en' in appTitle ? appTitle['en'] : activeApp}</b>`
        }
      };
    })
  );
  private transloco = inject(TranslocoService);

  getTranslatedLabel(label: TranslatedLabel) {
    const lang = this.transloco.getActiveLang();

    if (!label) return '';

    if (lang in label) {
      return label[lang];
    }

    if (Object.keys(label).length > 0) {
      return label[Object.keys(label)[0]];
    }

    return '';
  }
}
